import React, { useEffect, useState } from 'react'
import ConnectButton from '../components/ConnectButton'
import { useAdminStats } from '../hooks/useBscAccount'
import { useAccount, useNetwork } from 'wagmi'
import stakeABi from '../json/bscstake.json';
import { DEFAULT_CHAIN, contract } from '../helper/constant';
import { useEthersSigner } from '../hooks/useEthersProvider';
import { toast } from 'react-toastify';
import { getContract } from '../helper/contractHelper';
import { getWeb3 } from '../helper/functions';
import { ethers } from 'ethers';

export default function Admin() {
    const { address } = useAccount();
    const  { chain } = useNetwork();
    const signer = useEthersSigner();
    const [inputs, setInputs] = useState({
        withdraw_token_address: "",
        withdraw_token_amount: "",
        withdraw_token_decimals: "",
        new_owner: "",
        ref_per: "",
        deposit_pauser: "",
        withdraw_pauser: "",
        claim_pauser: "",
        claim_time: 0,
        default_referral: "",
        pair_address: "",
        stake_amounts: "",
    })
    const [updater, setUpdater] = useState(1);
    const stats = useAdminStats(updater)

    useEffect(() => {
        setInputs({
            ...inputs,
            new_owner: stats.owner,
            deposit_pauser: stats.pauser,
            withdraw_pauser: stats.wpauser,
            claim_pauser: stats.cpauser,
            default_referral: stats.default_referral,
            pair_address: stats.pair_address,
            stake_amounts: stats.stake_amounts,
            ref_per: stats.ref_per
        })
    }, [stats])


    const handleChange = (e) => {
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = async(id = 0) => {
        if (address && id) {
            if (chain.id === DEFAULT_CHAIN) {
                try {
                    let tokenContract = getContract(stakeABi, contract[DEFAULT_CHAIN].STAKE_ADDRESS, signer);
                    let tx;
                    if(id === 1){
                        tx = await tokenContract.rescueFunds({ 'from': address });
                    }
                    else if(id === 2){
                        tx = await tokenContract.rescueToken({ 'from': address });
                    }
                    else if(id === 3){
                        let a = ethers.utils.parseUnits(inputs.withdraw_token_amount.toString() , inputs.withdraw_token_decimals);
                        tx = await tokenContract.withdrawErc20Token( inputs.withdraw_token_address , a ,{ 'from': address });
                    }
                    else if(id === 4){
                        tx = await tokenContract.transferOwnership( inputs.new_owner,{ 'from': address });
                    }
                    else if(id === 5){
                        let ref_array = inputs.ref_per.split(',');
                        let a = ref_array.map((items) => items * 100);
                        tx = await tokenContract.setReferralLevel( a ,{ 'from': address });
                    }
                    else if(id === 6){
                        tx = await tokenContract.setPauser( inputs.deposit_pauser ,{ 'from': address });
                    }
                    else if(id === 7){
                        tx = await tokenContract.setWPauser( inputs.withdraw_pauser ,{ 'from': address });
                    }
                    else if(id === 8){
                        tx = await tokenContract.setCPauser( inputs.withdraw_pauser ,{ 'from': address });
                    }
                    else if(id === 9){
                        tx = await tokenContract.setClaimDays( inputs.claim_time ,{ 'from': address });
                    }
                    else if(id === 10){
                        tx = await tokenContract.setDefaultReferral( inputs.default_referral ,{ 'from': address });
                    }
                    else if(id === 11){
                        tx = await tokenContract.setPairAddress( inputs.pair_address ,{ 'from': address });
                    }
                    else if(id === 12){
                        let ref_array = inputs.stake_amounts.split(',');
                        let a = ref_array.map((items) => ethers.utils.parseEther(items.stake_amounts.toString()));
                        tx = await tokenContract.setStakeAmounts( a ,{ 'from': address });
                    }
                    else{
                        return false;
                    }



                    const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 5000));
                    toast.promise(
                        resolveAfter3Sec,
                        {
                            pending: 'Waiting for confirmation',
                        }
                    )

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(DEFAULT_CHAIN);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.success('success ! your last transaction is success 👍');
                                
                                setUpdater(Math.random());
                            }
                            else if (response.status === false) {
                                toast.error('error ! Your last transaction is failed.');
                                
                                setUpdater(Math.random());
                            }
                            else {
                                toast.error('error ! something went wrong.');
                                
                                setUpdater(Math.random());
                            }
                        }
                    }, 5000);
                }
                catch (err) {
                    console.log(err.message)
                    toast.error(err.reason ? err.reason : err.message);
                    
                }
            }
            else {
                toast.error('Please select Binance Mainnet Network !');
                
            }

        }
        else {
            toast.error('Please Connect Wallet!');
            
        }
    }


    return (
        <>
            <div className='d-flex justify-content-between m-5'>
                <h5>Admin Settings</h5>
                <ConnectButton />
            </div>
            <div className='mt-5'>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Input</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>rescueFunds</td>
                            <td></td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(1)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>rescueToken</td>
                            <td></td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(2)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">3</th>
                            <td>withdrawErc20Token</td>
                            <td>
                                <input value={inputs.withdraw_token_address} onChange={(e) => handleChange(e)} placeholder='Enter token address' type='text' name='withdraw_token_address' className='form-control' />
                                <input value={inputs.withdraw_token_amount} onChange={(e) => handleChange(e)} placeholder='Enter token amount' type='text' name='withdraw_token_amount' className='form-control' />
                                <input value={inputs.withdraw_token_decimals} onChange={(e) => handleChange(e)} placeholder='Enter token decimals' type='number' name='withdraw_token_decimals' className='form-control' />
                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(3)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">4</th>
                            <td>Transfer Ownership</td>
                            <td>
                                <input value={inputs.new_owner} onChange={(e) => handleChange(e)} placeholder='Enter new  owner address' type='text' name='new_owner' className='form-control' />
                            </td>
                            <td>
                                <button  type='button' onClick={()=>handleSubmit(4)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">5</th>
                            <td>Referral Level Percentage</td>
                            <td>
                                <input value={inputs.ref_per} onChange={(e) => handleChange(e)} placeholder='Enter with comma seprated' type='text' name='ref_per' className='form-control' />
                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(5)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">6</th>
                            <td>Deposit Pauser</td>
                            <td>
                                <select  onChange={(e) => handleChange(e)} name='deposit_pauser' class="form-select" aria-label="Default select example">
                                    <option value={true} selected={inputs.deposit_pauser === true || inputs.deposit_pauser === "true"}>True</option>
                                    <option value={false} selected={inputs.deposit_pauser === false || inputs.deposit_pauser === "false"}>False</option>
                                </select>

                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(6)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">7</th>
                            <td>Withdraw Pauser</td>
                            <td>
                                <select  onChange={(e) => handleChange(e)} name="withdraw_pauser" class="form-select" aria-label="Default select example">
                                    <option value={true} selected={inputs.withdraw_pauser === true || inputs.withdraw_pauser === "true"}>True</option>
                                    <option value={false} selected={inputs.withdraw_pauser === false || inputs.withdraw_pauser === "false"}>False</option>
                                </select>

                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(7)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">8</th>
                            <td>Claim Pauser</td>
                            <td>
                                <select  onChange={(e) => handleChange(e)} name="claim_pauser" class="form-select" aria-label="Default select example">
                                    <option value={true} selected={inputs.claim_pauser === true || inputs.claim_pauser === "true"}>True</option>
                                    <option value={false} selected={inputs.claim_pauser === false || inputs.claim_pauser === "false"}>False</option>
                                </select>

                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(8)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">9</th>
                            <td>Claim Time</td>
                            <td>
                                <input value={inputs.claim_time} onChange={(e) => handleChange(e)} placeholder='Enter Claim time in seconds' type='text' name='claim_time' className='form-control' />

                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(9)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">10</th>
                            <td> Default Referral</td>
                            <td>
                                <input value={inputs.default_referral} onChange={(e) => handleChange(e)} placeholder='Enter Default Referral Address' type='text' name='default_referral' className='form-control' />

                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(10)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">11</th>
                            <td>Pair Address</td>
                            <td>
                                <input value={inputs.pair_address} onChange={(e) => handleChange(e)} placeholder='Enter pair Address' type='text' name='pair_address' className='form-control' />

                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(11)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">12</th>
                            <td>Stake Amounts</td>
                            <td>
                                <input value={inputs.stake_amounts} onChange={(e) => handleChange(e)} placeholder='Enter amount with comma seprated' type='text' name='stake_amounts' className='form-control' />

                            </td>
                            <td>
                                <button type='button' onClick={()=>handleSubmit(12)} className='btn btn-success'>Submit</button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </>
    )
}
